import styled from 'styled-components';

export const HeaderContainer = styled.header`
  padding: 0.75rem 4rem;
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.101025);
  z-index: 2;
  position: relative;

  .action-section {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  @media only screen and (max-width: 768px) {
    padding: 0.75rem 1rem !important;
    border-radius: 0;
    gap: 8px;
  }

  .info {
    margin-left: auto;
  }

  .button__group {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const EditorContainer = styled.div`
  background-color: #f5f6f8;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  gap: 24px;

  .font-size-editor {
    display: flex;
    .left.monday-style-button {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .right.monday-style-button {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
  }
  .button,
  .size-counter {
    height: 40px;
    width: 40px;
    outline: none;
    border: 1px solid #c5c7d0;
    font-size: 24px;
    color: #676879;
    background-color: transparent;
  }
  .size-counter {
    width: 60px;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
    border-left: none;
    border-right: none;
  }
`;
